import {WorkingSizeContext, WorkingSizeDispatch} from "../context/WorkingSizeContext";
import {useContext, useState, useEffect} from "react";
import {useLanguage} from "../context/LanguageContext";

const minWidth = 20;
const maxWidth = 70;
const minHeight = 20;
const maxHeight = 70;
const minScale = 0.3;
const maxScale = 1;

const WorkingSizeSelector = () => {
    const {t} = useLanguage();
    const workingSizeContext = useContext(WorkingSizeContext);
    const dispatch = useContext(WorkingSizeDispatch);

    // Lokalne stany dla inputów
    const [width, setWidth] = useState(workingSizeContext.widthCm);
    const [height, setHeight] = useState(workingSizeContext.heightCm);
    const [scale, setScale] = useState(workingSizeContext.scale);

    // Stan błędu
    const [error, setError] = useState('');

    // Synchronizuj lokalny stan z kontekstem po zmianie kontekstu
    useEffect(() => {
        setWidth(workingSizeContext.widthCm);
        setHeight(workingSizeContext.heightCm);
        setScale(workingSizeContext.scale);
    }, [workingSizeContext.widthCm, workingSizeContext.heightCm, workingSizeContext.scale]);

    // Walidacja po każdej zmianie inputów
    useEffect(() => {
        let err = '';
        if (width < minWidth || width > maxWidth) {
            err = t('workingSize.widthRangeError', {min: minWidth, max: maxWidth});
        } else if (height < minHeight || height > maxHeight) {
            err = t('workingSize.heightRangeError', {min: minHeight, max: maxHeight});
        } else if (scale < minScale || scale > maxScale) {
            err = t('workingSize.scaleRangeError', {min: minScale, max: maxScale});
        }
        setError(err);
    }, [width, height, scale]);

    const handleWidthChange = (e) => {
        setWidth(Number(e.target.value));
    };

    const handleHeightChange = (e) => {
        setHeight(Number(e.target.value));
    };

    const handleScaleChange = (e) => {
        setScale(Number(e.target.value));
    };

    const handleApply = (e) => {
        e.preventDefault();
        if (!error) {
            dispatch({
                type: 'setWorkingSizeCm',
                payload: {
                    widthCm: width,
                    heightCm: height
                }
            });
            dispatch({
                type: 'setScale',
                payload: { scale }
            });
        }
    };

    return (
        <div className="row" style={{ flexWrap : 'wrap' , alignItems: 'center', justifyContent: 'center' }}>
            <div className="h3" style={{textAlign: "center"}}>{t('workingSize.title')}</div>
            <label className="col-3">{t('workingSize.widthLabel')}
                <input
                    className="mt-2 w-100"
                    type="number"
                    id="workingSizeWidth"
                    min={minWidth}
                    max={maxWidth}
                    placeholder={t('workingSize.widthPlaceholder')}
                    aria-label={t('workingSize.widthAriaLabel')}
                    value={width}
                    onChange={handleWidthChange}
                />
            </label>
            <label className="col-3">{t('workingSize.heightLabel')}
                <input
                    className="mt-2 w-100"
                    type="number"
                    min={minHeight}
                    max={maxHeight}
                    id="workingSizeHeight"
                    placeholder={t('workingSize.heightPlaceholder')}
                    aria-label={t('workingSize.heightAriaLabel')}
                    value={height}
                    onChange={handleHeightChange}
                />
            </label>
            <label className="col-2">{t('workingSize.scaleLabel')}
                <input
                    className="mt-2 w-100"
                    type="number"
                    min={minScale}
                    max={maxScale}
                    step="0.1"
                    id="workingSizeScale"
                    placeholder={t('workingSize.scalePlaceholder')}
                    aria-label={t('workingSize.scaleAriaLabel')}
                    value={scale}
                    onChange={handleScaleChange}
                />
            </label>
            {/* Komunikat błędu */}
            {error && (
                <span
                    style={{
                        fontSize: '1.2rem',
                        color: 'red',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        width: '100%',
                        margin: '10px 0'
                    }}
                >
                    {error}
                </span>
            )}
            <div className="col-12" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <button
                    className="btn btn--secondary"
                    onClick={handleApply}
                    disabled={!!error}
                >
                    {t('workingSize.applyChanges')}
                </button>
            </div>
        </div>
    )
}

export default WorkingSizeSelector;